import {
  AccordionV4,
  AccordionV4Item,
  BoxV2Icon,
  CreditCardIcon,
  ThumbsUpIcon,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import Video from '@/app/components/Video/Video';

import RingOutlineIcon from './RingOutlineIcon';
import TargetBestBuyIcons from './TargetBestBuyIcons';

export default function SizingModalContent() {
  const t = useTranslations();

  return (
    <div data-cy="sizing-modal-content">
      <TypographyV3
        className="mb-8 hidden text-2xl font-normal tracking-tighter md:block md:pr-12"
        Element="h2"
        variant="h2"
      >
        <RichText messageKey="ring_pdp_2025_sizing_modal_title" />
      </TypographyV3>
      <div className="flex flex-col items-start gap-0 md:gap-8 lg:flex-row lg:gap-16">
        <div className="w-full lg:w-[386px]">
          <Video
            className="mb-4 w-full rounded-[20px] object-cover md:mb-6 lg:h-[235px]"
            contentTitle="or4_sizing_video"
            location="sizing-hero"
            localizedSrc="sizing_gen4_sizing_video_src"
            playVideo={false}
            preload="metadata"
            type="video/mp4"
            posterSrc="sizing/video-poster.png"
          />
          <TypographyV3
            className="mb-8 text-xl font-normal tracking-tighter md:hidden md:pr-12"
            Element="h2"
            variant="h2"
          >
            <RichText messageKey="ring_pdp_2025_sizing_modal_title" />
          </TypographyV3>
          <div className="hidden flex-row items-center gap-3 md:flex">
            <TargetBestBuyIcons />
            <TypographyV3 className="text-sm font-bold text-sandstone-500">
              {t('ring_pdp_2025_sizing_modal_in_store_sizing')}
            </TypographyV3>
          </div>
        </div>
        <AccordionV4
          headerClassName="pr-4 text-base font-bold"
          className="mb-4 w-full flex-1 shrink grow gap-3 md:mb-0"
        >
          <AccordionV4Item
            header={t('ring_pdp_2025_sizing_modal_step_1_title')}
            icon={<CreditCardIcon />}
          >
            {t('ring_pdp_2025_sizing_modal_step_1_copy')}
          </AccordionV4Item>
          <AccordionV4Item
            header={t('ring_pdp_2025_sizing_modal_step_2_title')}
            icon={<BoxV2Icon />}
          >
            {t('ring_pdp_2025_sizing_modal_step_2_copy')}
          </AccordionV4Item>
          <AccordionV4Item
            header={t('ring_pdp_2025_sizing_modal_step_3_title')}
            icon={<ThumbsUpIcon />}
          >
            {t('ring_pdp_2025_sizing_modal_step_3_copy')}
          </AccordionV4Item>
          <AccordionV4Item
            header={t('ring_pdp_2025_sizing_modal_step_4_title')}
            icon={<RingOutlineIcon />}
          >
            {t('ring_pdp_2025_sizing_modal_step_4_copy')}
          </AccordionV4Item>
        </AccordionV4>
      </div>
      <div className="mt-8 mb-5 hidden h-px w-full bg-gray-300 md:block" />
      <TypographyV3 className="text-xs font-normal text-gray-400 italic lg:w-3/5">
        <RichText messageKey="ring_pdp_2025_sizing_modal_footnote_1" />
      </TypographyV3>
      <div className="mt-3 mb-6 h-px w-full bg-gray-300 md:hidden" />
      <div className="mb-5 flex flex-row items-center gap-3 md:hidden">
        <TargetBestBuyIcons />
        <TypographyV3 className="text-sm font-bold text-sandstone-500">
          {t('ring_pdp_2025_sizing_modal_in_store_sizing')}
        </TypographyV3>
      </div>
    </div>
  );
}
